import { Event } from '@weblite-wapps/protocol'
import { sendEventToWapp } from '$logic/wapp-communication/wapp-communication.publish'

// wappSessionId -> Event
const pendingEventsToSend: Record<string, Array<Event<any>>> = {}

export function addPendingEventToSend<P>(message: Event<P>) {
  const { wappSessionId } = message.meta

  const sessionEvents = pendingEventsToSend[wappSessionId]
  pendingEventsToSend[wappSessionId] = sessionEvents?.length
    ? sessionEvents.concat(message)
    : [message]
}

export function sendWappPendingMessages(wappSessionId: string) {
  const messagesToSend = pendingEventsToSend[wappSessionId]
  if (messagesToSend?.length) {
    messagesToSend.forEach(sendEventToWapp)
    pendingEventsToSend[wappSessionId] = undefined
  }
}
